import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import * as icons from 'icons'
import Input from 'react-toolbox/lib/input'

import styles from 'components/Form/Form.scss'
import theme from './error.scss'
import iconTheme from './icon.scss'

const TextInput = (props) => {
  const {
    icon,
    disabled,
    error,
    handleChange,
    label,
    focus,
    name,
    note,
    onBlur,
    onFocus,
    type,
    text,
    valid,
    maxLength,
    multiline,
    className,
    showSearchIcon,
  } = props
  const displayNote = (!valid) ? styles.isHidden : ''
  const focusIcon = (focus) ? styles.inputIconActive : ''

  const createIcon = (Icon, classes) => {
    return <Icon className={classes} height="16" width="16" />
  }

  const _handleBlur = (e) => {
    onBlur(name, e.target.value)
  }

  const _handleFocus = () => {
    onFocus(name)
  }

  const _handleChange = (value, e) => {
    handleChange(name, e.target.value)
  }

  return (
    <div className={iconTheme.base}>
      <Input
        className={classnames(styles.input, className)}
        disabled={disabled}
        error={error}
        label={label}
        maxLength={maxLength}
        multiline={multiline}
        name={name}
        onBlur={_handleBlur}
        onChange={_handleChange}
        onFocus={_handleFocus}
        theme={theme}
        type={type}
        value={text}
      />
      {(showSearchIcon) ? createIcon(icons.IconSearch, iconTheme.searchIcon) : null}
      {(icon) ? createIcon(icons[icon], classnames(styles.inputIcon, focusIcon)) : null}
      {(note) ? <span className={classnames(styles.note, displayNote)}>{note}</span> : null}
    </div>
  )
}

TextInput.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string || PropTypes.number,
  className: PropTypes.string,
  error: PropTypes.string,
  valid: PropTypes.bool,
  focus: PropTypes.bool,
  maxLength: PropTypes.number,
  multiline: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  note: PropTypes.string,
  showSearchIcon: PropTypes.bool,
}

TextInput.defaultProps = {
  text: '',
  icon: '',
  maxLength: null,
  multiline: false,
  error: '',
  valid: true,
  type: 'text',
  disabled: false,
  className: null,
  note: '',
  focus: false,
  showSearchIcon: false,
}

export default TextInput



// WEBPACK FOOTER //
// ./src/components/Form/components/TextInput/TextInput.js